module.exports = __webpack_public_path__ + "d8e3ed724badebe9236e397462b2edbc.png";